import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Button, Card, Col, Container, Form, Modal, OverlayTrigger, Row, Spinner, Table, Tooltip } from 'react-bootstrap'
import BootstrapTable from 'react-bootstrap-table-next'
import paginationFactory from 'react-bootstrap-table2-paginator'
import ToolkitProvider from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min'
import { SiMicrosoftexcel } from 'react-icons/si'
import { FaSort, FaSortUp, FaSortDown, FaFolder } from 'react-icons/fa'
import { Auth } from 'recupero-comunes'
import { ObtenerCompanias } from '../../../store/actions/encargado-cia-action'
import {
    buscarEmisionesAction,
    obtenerResumenPorCompaniaAction,
    obtenerDetallePagosAction,
    obtenerEstadoInformeEmisionAction,
    regenerarInformeEmisionAction,
    verCuponAction
} from '../../../store/actions/consulta-emision-pagos-action'
import { subirCuponAction, notificarCiaAction } from '../../../store/actions/emision-pagos-action'

const POLL_INTERVAL_MS = 5000
const POLL_MAX_INTENTOS = 12

const headerStyleGrilla = { backgroundColor: '#728bb0', color: 'white' }

const formatearFecha = (cell) => {
    if (!cell) return ''
    const fecha = new Date(cell)
    if (isNaN(fecha.getTime())) return cell
    const dia = String(fecha.getUTCDate()).padStart(2, '0')
    const mes = String(fecha.getUTCMonth() + 1).padStart(2, '0')
    const anio = fecha.getUTCFullYear()
    return `${dia}-${mes}-${anio}`
}

const sortHeaderFormatter = (column, colIndex, { sortElement }) => (
    <div>{column.text}{sortElement}</div>
)

const sortCaretGrilla = (order) => {
    if (!order) return <FaSort className='ms-1' style={{ color: 'white' }} />
    if (order === 'asc') return <FaSortUp className='ms-1' style={{ color: 'white' }} />
    return <FaSortDown className='ms-1' style={{ color: 'white' }} />
}

const sortNumerico = (a, b, order) => {
    const diff = Number(a || 0) - Number(b || 0)
    return order === 'asc' ? diff : -diff
}

const columnasDetallePagos = [
    {
        dataField: 'siniestroCIA', text: 'Siniestro CIA', sort: true, sortCaret: sortCaretGrilla, sortFunc: sortNumerico, headerStyle: headerStyleGrilla, headerFormatter: sortHeaderFormatter,
        formatter: (cell, row) => (
            <OverlayTrigger overlay={<Tooltip>ID Caso: {row.idCaso}</Tooltip>}>
                <span style={{ cursor: 'help' }}>{cell}</span>
            </OverlayTrigger>
        )
    },
    { dataField: 'fecSiniestroCIA', text: 'Fec.Siniestro', sort: true, sortCaret: sortCaretGrilla, headerStyle: headerStyleGrilla, headerFormatter: sortHeaderFormatter, formatter: formatearFecha },
    { dataField: 'fecIngCarta', text: 'Fec.Ing.Carta', sort: true, sortCaret: sortCaretGrilla, headerStyle: headerStyleGrilla, headerFormatter: sortHeaderFormatter, formatter: formatearFecha },
    { dataField: 'companiaTercero', text: 'Compañía Ter', sort: true, sortCaret: sortCaretGrilla, headerStyle: headerStyleGrilla, headerFormatter: sortHeaderFormatter },
    { dataField: 'siniestroTercero', text: 'Siniestro Ter', sort: true, sortCaret: sortCaretGrilla, sortFunc: sortNumerico, headerStyle: headerStyleGrilla, headerFormatter: sortHeaderFormatter },
    { dataField: 'fecAprobado', text: 'Fec.Aprob.', sort: true, sortCaret: sortCaretGrilla, headerStyle: headerStyleGrilla, headerFormatter: sortHeaderFormatter, formatter: formatearFecha },
    {
        dataField: 'montoPago', text: 'Monto Pago', sort: true, sortCaret: sortCaretGrilla, sortFunc: sortNumerico, align: 'right', headerAlign: 'right', headerStyle: headerStyleGrilla, headerFormatter: sortHeaderFormatter,
        formatter: (cell) => Number(cell || 0).toLocaleString('es-CL')
    },
    {
        dataField: 'motivoAprobado', text: 'Motivo Aprob.', sort: true, sortCaret: sortCaretGrilla, headerFormatter: sortHeaderFormatter,
        headerStyle: { ...headerStyleGrilla, width: '220px' },
        style: { whiteSpace: 'normal' }
    }
]

const IconoLupa = () => (
    <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='currentColor' className='bi bi-search' viewBox='0 0 16 16'>
        <path d='M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z' />
    </svg>
)

const IconoCarpeta = () => <FaFolder size={14} />

const ConsultaEmisionPagos = () => {
    const dispatch = useDispatch()
    const { rutUsuario, rutOrganizacion } = Auth.currentUser()

    const dataCompanias = useSelector((state) => state.encargado_compania)
    const listaCompanias = dataCompanias?.companias?.companias || []

    const dataConsulta = useSelector((state) => state.consultaEmisionPagosReducer)
    const emisiones = dataConsulta.emisiones || []
    const resumenCompania = dataConsulta.resumenCompania || []
    const detallePagos = dataConsulta.detallePagos || []

    const [filtros, setFiltros] = useState({ fechaDesde: '', fechaHasta: '', companiaId: '' })
    const [errorFechas, setErrorFechas] = useState('')
    const [cargando, setCargando] = useState(false)

    const [emisionSeleccionada, setEmisionSeleccionada] = useState(null)
    const [informeListo, setInformeListo] = useState(false)
    const [refrescandoInforme, setRefrescandoInforme] = useState(false)
    const [notificarSeleccionadas, setNotificarSeleccionadas] = useState({})
    const [errorNotificar, setErrorNotificar] = useState('')
    const [mensajesNotificacion, setMensajesNotificacion] = useState([])
    const [showConfirmNotificar, setShowConfirmNotificar] = useState(false)
    const [notificando, setNotificando] = useState(false)

    const [showDetalle, setShowDetalle] = useState(false)
    const [cargandoDetalle, setCargandoDetalle] = useState(false)

    const [showConfirmReemplazar, setShowConfirmReemplazar] = useState(false)
    const [subiendoCupon, setSubiendoCupon] = useState(null)

    const [showCupon, setShowCupon] = useState(false)
    const [urlCupon, setUrlCupon] = useState(null)
    const [tipoArchivoCupon, setTipoArchivoCupon] = useState('pdf')

    const pollRef = useRef({ intentos: 0, timer: null })
    const solicitudEnviadaRef = useRef(false)
    const fileInputRef = useRef(null)
    const cuponTargetRef = useRef(null)

    useEffect(() => {
        dispatch(ObtenerCompanias(Buffer.from(JSON.stringify({})).toString('base64')))
        buscar()
        return () => detenerPolling()
    }, [])

    const detenerPolling = () => {
        if (pollRef.current.timer) {
            clearInterval(pollRef.current.timer)
            pollRef.current.timer = null
        }
    }

    const buscar = () => {
        if (filtros.fechaDesde && filtros.fechaHasta && filtros.fechaDesde > filtros.fechaHasta) {
            setErrorFechas('"Emitido Desde" no puede ser posterior a "Emitido Hasta".')
            return
        }
        setErrorFechas('')
        let parametros = {}
        if (filtros.fechaDesde) parametros.fechaEmitidoDesde = filtros.fechaDesde
        if (filtros.fechaHasta) parametros.fechaEmitidoHasta = filtros.fechaHasta
        if (filtros.companiaId) parametros.compania = { id: filtros.companiaId }
        const query = Buffer.from(JSON.stringify(parametros)).toString('base64')
        setCargando(true)
        dispatch(buscarEmisionesAction(query)).then(() => setCargando(false)).catch(() => setCargando(false))
    }

    const handleLimpiar = () => {
        setFiltros({ fechaDesde: '', fechaHasta: '', companiaId: '' })
        setErrorFechas('')
    }

    const consultarEstadoInforme = (idEmision) => {
        const query = Buffer.from(JSON.stringify({ accion: 'estadoEmision', idEmision })).toString('base64')
        return dispatch(obtenerEstadoInformeEmisionAction(query))
    }

    const iniciarPollingEstadoInforme = (idEmision) => {
        detenerPolling()
        pollRef.current.intentos = 0
        pollRef.current.timer = setInterval(() => {
            pollRef.current.intentos += 1
            consultarEstadoInforme(idEmision)
            if (pollRef.current.intentos >= POLL_MAX_INTENTOS) {
                detenerPolling()
            }
        }, POLL_INTERVAL_MS)
    }

    useEffect(() => {
        if (!dataConsulta.estadoInforme || !emisionSeleccionada) return
        if (dataConsulta.estadoInforme.listo) {
            setInformeListo(true)
            detenerPolling()
            return
        }
        setInformeListo(false)
        if (!solicitudEnviadaRef.current) {
            solicitudEnviadaRef.current = true
            dispatch(regenerarInformeEmisionAction({
                idEmision: emisionSeleccionada.idEmision,
                idOrganizacion: rutOrganizacion,
                idUsuario: rutUsuario
            }))
            iniciarPollingEstadoInforme(emisionSeleccionada.idEmision)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataConsulta.estadoInforme])

    const refrescarResumen = (idEmision) => {
        const query = Buffer.from(JSON.stringify({ accion: 'detalleEmision', idEmision })).toString('base64')
        dispatch(obtenerResumenPorCompaniaAction(query))
    }

    const seleccionarEmision = (row) => {
        detenerPolling()
        solicitudEnviadaRef.current = false
        setEmisionSeleccionada(row)
        setInformeListo(false)
        setNotificarSeleccionadas({})
        setErrorNotificar('')
        setMensajesNotificacion([])

        refrescarResumen(row.idEmision)
        consultarEstadoInforme(row.idEmision)
    }

    const handleRefrescarEstado = () => {
        if (!emisionSeleccionada) return
        setRefrescandoInforme(true)
        consultarEstadoInforme(emisionSeleccionada.idEmision)
            .then(() => setRefrescandoInforme(false))
            .catch(() => setRefrescandoInforme(false))
    }

    const handleDescargarExcel = () => {
        if (!emisionSeleccionada) return
        setRefrescandoInforme(true)
        const query = Buffer.from(JSON.stringify({ accion: 'estadoEmision', idEmision: emisionSeleccionada.idEmision })).toString('base64')
        dispatch(obtenerEstadoInformeEmisionAction(query))
            .then((resultAction) => {
                setRefrescandoInforme(false)
                const estado = resultAction.payload
                if (estado && estado.listo && estado.url) {
                    const link = document.createElement('a')
                    link.href = estado.url
                    link.click()
                }
            })
            .catch(() => setRefrescandoInforme(false))
    }

    const handleVerDetalle = () => {
        if (!emisionSeleccionada) return
        setShowDetalle(true)
        setCargandoDetalle(true)
        const query = Buffer.from(JSON.stringify({ accion: 'detallePagos', idEmision: emisionSeleccionada.idEmision })).toString('base64')
        dispatch(obtenerDetallePagosAction(query))
            .then(() => setCargandoDetalle(false))
            .catch(() => setCargandoDetalle(false))
    }

    // --- Cupón de pago ---

    const handleCarpeta = (cia) => {
        cuponTargetRef.current = cia
        if (cia.urlCuponPago) {
            setShowConfirmReemplazar(true)
        } else {
            fileInputRef.current.click()
        }
    }

    const handleConfirmarReemplazar = () => {
        setShowConfirmReemplazar(false)
        fileInputRef.current.click()
    }

    const handleFileSelected = (e) => {
        const file = e.target.files[0]
        if (!file) return
        const cia = cuponTargetRef.current
        const ext = file.name.split('.').pop()
        e.target.value = ''

        setSubiendoCupon(cia.rutCia)
        dispatch(subirCuponAction({
            accion: 'subirCupon',
            idEmision: emisionSeleccionada.idEmision,
            rutCia: cia.rutCia,
            extension: ext,
            idOrganizacion: rutOrganizacion,
            idUsuario: rutUsuario
        }))
            .then(async (resultAction) => {
                const { urlSubida, contentType } = resultAction.payload
                await fetch(urlSubida, { method: 'PUT', body: file, headers: { 'Content-Type': contentType } })
                refrescarResumen(emisionSeleccionada.idEmision)
            })
            .catch((err) => console.error('Error al subir cupón:', err))
            .finally(() => setSubiendoCupon(null))
    }

    const handleLupa = (cia) => {
        const ext = (cia.urlCuponPago || '').split('.').pop().toLowerCase()
        setTipoArchivoCupon(ext === 'pdf' ? 'pdf' : 'image')
        const query = Buffer.from(JSON.stringify({ accion: 'verCupon', idEmision: emisionSeleccionada.idEmision, rutCia: cia.rutCia })).toString('base64')
        dispatch(verCuponAction(query)).then((resultAction) => {
            setUrlCupon(resultAction.payload?.url || null)
            setShowCupon(true)
        })
    }

    // --- Notificar ---

    const todasNotificarSeleccionadas = resumenCompania.length > 0 && resumenCompania.every((r) => notificarSeleccionadas[r.rutCia])

    const handleToggleNotificar = (rutCia) => {
        setNotificarSeleccionadas((prev) => ({ ...prev, [rutCia]: !prev[rutCia] }))
        setErrorNotificar('')
    }

    const handleToggleNotificarTodos = (checked) => {
        const nuevo = {}
        resumenCompania.forEach((r) => { nuevo[r.rutCia] = checked })
        setNotificarSeleccionadas(nuevo)
        setErrorNotificar('')
    }

    const handleNotificarCiasClick = () => {
        const seleccionadas = resumenCompania.filter((r) => notificarSeleccionadas[r.rutCia])
        if (seleccionadas.length === 0) {
            setErrorNotificar('Debe seleccionar a lo menos una Compañía para su notificación.')
            return
        }
        const sinCupon = seleccionadas.filter((r) => !r.urlCuponPago)
        if (sinCupon.length > 0) {
            setErrorNotificar(`Sin comprobante de pago: ${sinCupon.map((r) => r.compania).join(', ')}.`)
            return
        }
        setErrorNotificar('')
        setShowConfirmNotificar(true)
    }

    const handleConfirmarNotificar = async () => {
        setShowConfirmNotificar(false)
        setNotificando(true)
        const seleccionadas = resumenCompania.filter((r) => notificarSeleccionadas[r.rutCia])
        const mensajes = []
        for (const cia of seleccionadas) {
            try {
                await dispatch(notificarCiaAction({
                    accion: 'notificarCia',
                    idEmision: emisionSeleccionada.idEmision,
                    rutCia: cia.rutCia,
                    nombreCia: cia.compania,
                    urlCuponPago: cia.urlCuponPago,
                    idOrganizacion: rutOrganizacion,
                    idUsuario: rutUsuario
                }))
                mensajes.push(`Notificación encolada. (${cia.compania})`)
            } catch {
                mensajes.push(`Error al encolar notificación para ${cia.compania}.`)
            }
        }
        setMensajesNotificacion(mensajes)
        setNotificarSeleccionadas({})
        setNotificando(false)
    }

    const columnasEmisiones = [
        { dataField: 'idEmision', text: 'Id Emisión', sort: true, sortCaret: sortCaretGrilla, sortFunc: sortNumerico, headerStyle: headerStyleGrilla, headerFormatter: sortHeaderFormatter },
        { dataField: 'fechaEmision', text: 'Fec.Emisión', sort: true, sortCaret: sortCaretGrilla, headerStyle: headerStyleGrilla, headerFormatter: sortHeaderFormatter, formatter: formatearFecha },
        {
            dataField: 'montoPagado', text: 'Monto Pagado', sort: true, sortCaret: sortCaretGrilla, sortFunc: sortNumerico, align: 'right', headerAlign: 'right', headerStyle: headerStyleGrilla, headerFormatter: sortHeaderFormatter,
            formatter: (cell) => Number(cell || 0).toLocaleString('es-CL')
        },
        { dataField: 'cantidadPagos', text: 'Cnt.Pagos', sort: true, sortCaret: sortCaretGrilla, sortFunc: sortNumerico, align: 'right', headerAlign: 'right', headerStyle: headerStyleGrilla, headerFormatter: sortHeaderFormatter },
        { dataField: 'ciasConPago', text: 'CIAs c/Pago', sort: true, sortCaret: sortCaretGrilla, sortFunc: sortNumerico, align: 'right', headerAlign: 'right', headerStyle: headerStyleGrilla, headerFormatter: sortHeaderFormatter },
        { dataField: 'nombreUsrEmision', text: 'Usr.Emisión', sort: true, sortCaret: sortCaretGrilla, headerStyle: headerStyleGrilla, headerFormatter: sortHeaderFormatter },
        {
            dataField: 'accion', text: 'Acción', headerStyle: headerStyleGrilla, align: 'center', headerAlign: 'center',
            formatter: (cell, row) => (
                <OverlayTrigger overlay={<Tooltip>Ver detalle</Tooltip>}>
                    <Button type='button' variant='outline-secondary' size='sm' onClick={() => seleccionarEmision(row)}>
                        <IconoLupa />
                    </Button>
                </OverlayTrigger>
            )
        }
    ]

    return (
        <Container>
            <Card className='mt-2'>
                <Card.Header as='h6' style={{ backgroundColor: '#4F517A', color: 'white', textAlign: 'center' }}>
                    Consulta Emisión de Pagos
                </Card.Header>
                <Card.Body>
                    <Row>
                        <Col md='3'>
                            <Form.Label style={{ fontWeight: 'bold', fontSize: '14px' }}>Emitido Desde</Form.Label>
                            <Form.Control type='date' value={filtros.fechaDesde} max={filtros.fechaHasta || undefined} isInvalid={!!errorFechas}
                                onChange={(e) => { setFiltros({ ...filtros, fechaDesde: e.target.value }); setErrorFechas('') }} />
                        </Col>
                        <Col md='3'>
                            <Form.Label style={{ fontWeight: 'bold', fontSize: '14px' }}>Emitido Hasta</Form.Label>
                            <Form.Control type='date' value={filtros.fechaHasta} min={filtros.fechaDesde || undefined} isInvalid={!!errorFechas}
                                onChange={(e) => { setFiltros({ ...filtros, fechaHasta: e.target.value }); setErrorFechas('') }} />
                            <Form.Control.Feedback type='invalid'>{errorFechas}</Form.Control.Feedback>
                        </Col>
                        <Col md='6'>
                            <Form.Label style={{ fontWeight: 'bold', fontSize: '14px' }}>Compañía Tercero</Form.Label>
                            <Form.Select value={filtros.companiaId}
                                onChange={(e) => setFiltros({ ...filtros, companiaId: e.target.value })}>
                                <option value=''>Seleccione...</option>
                                {listaCompanias.map((c) => (
                                    <option key={c.id} value={c.id}>{c.nombre}</option>
                                ))}
                            </Form.Select>
                        </Col>
                    </Row>
                    <Row className='mt-3'>
                        <Col className='d-flex justify-content-end'>
                            <Button variant='outline-warning' className='me-2' disabled={cargando} onClick={handleLimpiar}>Limpiar</Button>
                            <Button variant='success' disabled={cargando} onClick={buscar}>
                                {cargando && <Spinner as='span' animation='border' size='sm' className='me-2' />}
                                Buscar
                            </Button>
                        </Col>
                    </Row>

                    <Container className='mt-3 p-0'>
                        <div style={{ backgroundColor: '#4F517A', color: 'white' }} className='px-2 py-1 fw-bold'>
                            Detalle Emisión Seleccionada
                        </div>
                        <Row className='mt-2'>
                            <Col md='6'>
                                <Row>
                                    <Col md='3'>
                                        <Form.Label style={{ fontWeight: 'bold', fontSize: '14px' }}>Id Emisión</Form.Label>
                                        <Form.Control disabled value={emisionSeleccionada?.idEmision || ''} />
                                    </Col>
                                    <Col md='3'>
                                        <Form.Label style={{ fontWeight: 'bold', fontSize: '14px' }}>Fecha Emisión</Form.Label>
                                        <Form.Control disabled value={formatearFecha(emisionSeleccionada?.fechaEmision)} />
                                    </Col>
                                    <Col md='3'>
                                        <Form.Label style={{ fontWeight: 'bold', fontSize: '14px' }}>Monto Pagado</Form.Label>
                                        <Form.Control disabled value={Number(emisionSeleccionada?.montoPagado || 0).toLocaleString('es-CL')} />
                                    </Col>
                                    <Col md='3'>
                                        <Form.Label style={{ fontWeight: 'bold', fontSize: '14px' }}>Cantidad Pagos</Form.Label>
                                        <Form.Control disabled value={emisionSeleccionada?.cantidadPagos || ''} />
                                    </Col>
                                </Row>
                                <Row className='mt-3'>
                                    <Col className='d-flex align-items-center'>
                                        <OverlayTrigger overlay={<Tooltip>{informeListo ? 'Descargar excel' : (emisionSeleccionada ? 'Generando informe…' : 'Seleccione una emisión')}</Tooltip>}>
                                            <span>
                                                <Button variant='outline-success' className='me-2' disabled={!emisionSeleccionada || !informeListo || refrescandoInforme} onClick={handleDescargarExcel}>
                                                    {refrescandoInforme ? <Spinner as='span' animation='border' size='sm' /> : <SiMicrosoftexcel />}
                                                </Button>
                                            </span>
                                        </OverlayTrigger>
                                        {emisionSeleccionada && !informeListo && (
                                            <Button variant='outline-info' size='sm' disabled={refrescandoInforme} onClick={handleRefrescarEstado}>
                                                Refrescar estado
                                            </Button>
                                        )}
                                    </Col>
                                </Row>
                            </Col>
                            <Col md='6'>
                                {resumenCompania.length > 0 && (
                                    <div style={{ overflowX: 'auto' }}>
                                        <Table size='sm' bordered>
                                            <thead>
                                                <tr>
                                                    <th style={headerStyleGrilla}>
                                                        <Form.Check type='checkbox' checked={todasNotificarSeleccionadas} onChange={(e) => handleToggleNotificarTodos(e.target.checked)} />
                                                    </th>
                                                    <th style={headerStyleGrilla}>Compañía</th>
                                                    <th style={headerStyleGrilla}>Monto Pago</th>
                                                    <th style={headerStyleGrilla}>Cnt.Pago</th>
                                                    <th style={headerStyleGrilla}>Notifica</th>
                                                    <th style={headerStyleGrilla}>Acción</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {resumenCompania.map((r) => (
                                                    <tr key={r.rutCia}>
                                                        <td><Form.Check type='checkbox' checked={!!notificarSeleccionadas[r.rutCia]} onChange={() => handleToggleNotificar(r.rutCia)} /></td>
                                                        <td>{r.compania}</td>
                                                        <td>{Number(r.monto || 0).toLocaleString('es-CL')}</td>
                                                        <td>{r.cantidad}</td>
                                                        <td style={{ whiteSpace: 'nowrap', fontSize: '12px' }}>{formatearFecha(r.fechaNotifica)}</td>
                                                        <td style={{ whiteSpace: 'nowrap' }}>
                                                            {r.urlCuponPago && (
                                                                <OverlayTrigger overlay={<Tooltip>Ver comprobante</Tooltip>}>
                                                                    <Button type='button' variant='outline-primary' size='sm' className='me-1 p-1' onClick={() => handleLupa(r)}>
                                                                        <IconoLupa />
                                                                    </Button>
                                                                </OverlayTrigger>
                                                            )}
                                                            <OverlayTrigger overlay={<Tooltip>{r.urlCuponPago ? 'Reemplazar comprobante' : 'Cargar comprobante'}</Tooltip>}>
                                                                <Button type='button' variant='outline-warning' size='sm' className='p-1'
                                                                    disabled={subiendoCupon === r.rutCia}
                                                                    onClick={() => handleCarpeta(r)}>
                                                                    {subiendoCupon === r.rutCia
                                                                        ? <Spinner as='span' animation='border' size='sm' />
                                                                        : <IconoCarpeta />}
                                                                </Button>
                                                            </OverlayTrigger>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </Table>
                                    </div>
                                )}
                            </Col>
                        </Row>

                        <hr className='mt-3' />
                        <Row className='mt-2'>
                            <Col className='d-flex justify-content-end align-items-start flex-wrap gap-2'>
                                {mensajesNotificacion.length > 0 && (
                                    <div className='text-success small align-self-center me-2'>
                                        {mensajesNotificacion.map((m, i) => <div key={i}>{m}</div>)}
                                    </div>
                                )}
                                {errorNotificar && <div className='text-danger small align-self-center me-2'>{errorNotificar}</div>}
                                <Button variant='outline-primary' className='me-2' disabled={!emisionSeleccionada} onClick={handleVerDetalle}>Ver Detalle</Button>
                                <Button variant='danger' disabled={!emisionSeleccionada || notificando} onClick={handleNotificarCiasClick}>
                                    {notificando && <Spinner as='span' animation='border' size='sm' className='me-2' />}
                                    Notificar CIAs
                                </Button>
                            </Col>
                        </Row>
                    </Container>

                    <Container className='mt-3 p-0'>
                        <div style={{ backgroundColor: '#4F517A', color: 'white' }} className='px-2 py-1 fw-bold'>
                            Resultado Búsqueda ({emisiones.length})
                        </div>
                        {cargando ? (
                            <div className='text-center text-muted py-5'>
                                <Spinner animation='border' variant='primary' />
                            </div>
                        ) : (
                            <BootstrapTable
                                keyField='idEmision'
                                data={emisiones}
                                columns={columnasEmisiones}
                                bordered={false}
                                pagination={paginationFactory()}
                                noDataIndication={<div className='text-center text-muted fst-italic py-2'>No hay emisiones de pagos para los filtros seleccionados.</div>}
                            />
                        )}
                    </Container>
                </Card.Body>
            </Card>

            {/* Input oculto para selección de archivo cupón */}
            <input
                ref={fileInputRef}
                type='file'
                accept='.pdf,.jpg,.jpeg,.png'
                style={{ display: 'none' }}
                onChange={handleFileSelected}
            />

            {/* Modal Ver Detalle Pagos */}
            <Modal show={showDetalle} onHide={() => setShowDetalle(false)} size='xl'>
                <Modal.Header closeButton>
                    <Modal.Title>Detalle emisión de pagos {emisionSeleccionada?.idEmision} / {formatearFecha(emisionSeleccionada?.fechaEmision)}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {cargandoDetalle ? (
                        <div className='text-center text-muted py-5'>
                            <Spinner animation='border' variant='primary' />
                        </div>
                    ) : (
                        <ToolkitProvider search bootstrap4 keyField='__key'
                            data={detallePagos.map((row) => ({ ...row, __key: `${row.idCaso}_${row.idImplicado}` }))}
                            columns={columnasDetallePagos}>
                            {(props) => (
                                <div>
                                    <div className='d-grid gap-2 d-md-flex justify-content-md-end mt-2 mb-2'>
                                        <Form.Control placeholder='Buscar en la grilla' className='w-25' onChange={(e) => { props.searchProps.onSearch(e.target.value) }} />
                                    </div>
                                    <BootstrapTable
                                        {...props.baseProps}
                                        bordered={false}
                                        defaultSorted={[{ dataField: 'siniestroCIA', order: 'asc' }]}
                                        pagination={paginationFactory({ sizePerPageList: [{ text: '20', value: 20 }, { text: '50', value: 50 }] })}
                                        noDataIndication={<div className='text-center text-muted fst-italic py-2'>No hay pagos para esta emisión.</div>}
                                    />
                                </div>
                            )}
                        </ToolkitProvider>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant='outline-info' size='sm' onClick={handleVerDetalle}>Refrescar</Button>
                    <Button variant='secondary' onClick={() => setShowDetalle(false)}>Cerrar</Button>
                </Modal.Footer>
            </Modal>

            {/* Modal Confirmar Notificar */}
            <Modal show={showConfirmNotificar} onHide={() => setShowConfirmNotificar(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Confirmar Notificación</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Confirmar envío de correo a las Compañías seleccionadas adjuntando el comprobante de pago correspondiente.
                </Modal.Body>
                <Modal.Footer>
                    <Button variant='secondary' onClick={() => setShowConfirmNotificar(false)}>Cancelar</Button>
                    <Button variant='primary' onClick={handleConfirmarNotificar}>Confirmar</Button>
                </Modal.Footer>
            </Modal>

            {/* Modal Confirmar Reemplazar Cupón */}
            <Modal show={showConfirmReemplazar} onHide={() => setShowConfirmReemplazar(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Comprobante de pago</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Ya existe comprobante de pago. ¿Desea reemplazarlo?
                </Modal.Body>
                <Modal.Footer>
                    <Button variant='secondary' onClick={() => setShowConfirmReemplazar(false)}>No</Button>
                    <Button variant='primary' onClick={handleConfirmarReemplazar}>Sí</Button>
                </Modal.Footer>
            </Modal>

            {/* Modal Ver Cupón */}
            <Modal show={showCupon} onHide={() => { setShowCupon(false); setUrlCupon(null) }} size='lg'>
                <Modal.Header closeButton>
                    <Modal.Title>Comprobante de pago</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ minHeight: '500px' }}>
                    {urlCupon ? (
                        tipoArchivoCupon === 'pdf'
                            ? <iframe src={urlCupon} title='Comprobante' width='100%' height='480px' style={{ border: 'none' }} />
                            : <img src={urlCupon} alt='Comprobante' style={{ maxWidth: '100%' }} />
                    ) : (
                        <div className='text-center text-muted py-5'>No se pudo obtener el comprobante.</div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant='secondary' onClick={() => { setShowCupon(false); setUrlCupon(null) }}>Cerrar</Button>
                </Modal.Footer>
            </Modal>
        </Container>
    )
}

export default ConsultaEmisionPagos
